export default __webpack_public_path__ + "static/media/BIKE RIDING.e3ef78db.jpg";